import React from "react";
import CollapsibleHtmlContent from "components/common/CollapsibleHtmlContent";
import HtmlContent from "components/common/HtmlContent";

interface ProductContentProps {
  /** Main content to be displayed */
  content: string;
  /** Optional SEO collapsible content */
  seoCollapsibleContent?: {
    __typename: string;
    html: string | null;
  } | null;
  /** Optional class name for the container */
  className?: string;
}

/**
 * A component that displays product content, with optional collapsible SEO content.
 * This component can be used across all product types (courses, packages, webinars, etc.)
 */
const ProductContent: React.FC<ProductContentProps> = ({
  content,
  seoCollapsibleContent,
  className,
}) => {
  return (
    <div className={className}>
      <HtmlContent>{content}</HtmlContent>
      {seoCollapsibleContent?.html && <CollapsibleHtmlContent html={seoCollapsibleContent.html} />}
    </div>
  );
};

export default ProductContent;
